<template >
  <div class="inline-block">
    <div class="
      handle cursor-move
      w-4 pl-1 h-full
      flex items-center
      hover:opacity-50
    ">
      <IconDrag></IconDrag>
    </div>
  </div>
</template>

<script>
import IconDrag from '@/components/icons/IconDrag'

export default {
  name: 'RowDragHandle',
  components: {
    IconDrag
  }
}
</script>